import { Constants } from 'constants';

import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Grid, GaugeChart } from '@genie-ui/react';
import { useMediaQuery } from '@genie-ui/react/hooks';

import { getHighchartconfig } from 'utils';

import './GuageChart.scss';

function GuageChart({
  percentage,
  showCount,
}) {
  const isMobileResponsive = useMediaQuery('(min-width:600px) and (max-width:900px)');
  const isDesktopResponsive = useMediaQuery('(min-width:1200px)');
  const isResponsive = isMobileResponsive || isDesktopResponsive;

  return (
    <>
      <div className="chartRoot">
        <GaugeChart
          options={getHighchartconfig(isResponsive, percentage)}
          percent={percentage}
          label={`${percentage}%`}
        />
      </div>
      {showCount && (
      <>
        <Grid className="values">
          <Grid item>
            <Typography className="initialFinalVal">
              {Constants.GUAGE_CHART.INITIAL_VAL}
            </Typography>
          </Grid>
          <Grid item>
            <Typography className="initialFinalVal">
              {Constants.GUAGE_CHART.FINAL_VAL}
            </Typography>
          </Grid>
        </Grid>
        <Grid className="performer">
          <Typography className="top">{Constants.GUAGE_CHART.TOP_PERFORMERS}</Typography>
        </Grid>
      </>
      )}
    </>
  );
}

GuageChart.propTypes = {
  percentage: PropTypes.number,
  showCount: PropTypes.bool,
};

GuageChart.defaultProps = {
  percentage: 0,
  showCount: true,
};

export default GuageChart;
